<template>
  <div class="page-container">
    <el-card style="margin-bottom: 20px;">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input 
            v-model="keyword" 
            placeholder="搜索评论内容" 
            clearable
            @clear="loadData"
            @keyup.enter.native="loadData">
            <el-button slot="append" icon="el-icon-search" @click="loadData"></el-button>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input 
            v-model="filterResourceId" 
            placeholder="按资源ID过滤（可选）" 
            clearable
            @clear="loadData"
            @keyup.enter.native="loadData">
            <el-button slot="append" icon="el-icon-search" @click="loadData"></el-button>
          </el-input>
        </el-col>
      </el-row>
    </el-card>

    <el-card>
      <el-table :data="tableData" border v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="resourceTitle" label="资源标题"></el-table-column>
        <el-table-column prop="content" label="评论内容" min-width="260"></el-table-column>
        <el-table-column prop="userId" label="用户ID" width="120"></el-table-column>
        <el-table-column prop="likeCount" label="点赞" width="100"></el-table-column>
        <el-table-column prop="isTop" label="置顶" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isTop === 1 ? 'warning' : 'info'">{{ scope.row.isTop === 1 ? '已置顶' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="toggleTop(scope.row)">
              {{ scope.row.isTop === 1 ? '取消置顶' : '置顶' }}
            </el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="text-align: right; margin-top: 16px;">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="total"
          :current-page="current"
          @current-change="handlePageChange">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CommentManage',
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      current: 1,
      pageSize: 10,
      keyword: '',
      filterResourceId: ''
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleString('zh-CN')
    },
    async loadData() {
      this.loading = true
      try {
        const params = { current: this.current, size: this.pageSize }
        if (this.keyword && this.keyword.trim()) {
          params.keyword = this.keyword.trim()
        }
        if (this.filterResourceId && String(this.filterResourceId).trim()) {
          params.resourceId = this.filterResourceId
        }
        const res = await this.$axios.get('/admin/comment/page', { params })
        if (res.data.code === 200) {
          this.tableData = res.data.data.records || []
          this.total = res.data.data.total || 0
        }
      } catch (e) {
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    handlePageChange(page) {
      this.current = page
      this.loadData()
    },
    async toggleTop(row) {
      try {
        const target = row.isTop === 1 ? 0 : 1
        await this.$axios.post(`/admin/comment/top/${row.id}`, null, { params: { isTop: target } })
        this.$message.success(target === 1 ? '已置顶' : '已取消置顶')
        this.loadData()
      } catch (e) {
        this.$message.error('操作失败')
      }
    },
    handleDelete(row) {
      this.$confirm('确定删除该评论?', '提示', { type: 'warning' })
        .then(async () => {
          await this.$axios.delete(`/admin/comment/${row.id}`)
          this.$message.success('删除成功')
          this.loadData()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 20px;
  background: transparent;
  min-height: calc(100vh - 60px);
}
</style>
